<template>
  <div class="wrapper">
    <div class="ts-well" :class="{ small: size === 'small' }">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  box-shadow: inset -8px -8px 16px 0 #fafbff, inset 8px 8px 16px 0 #a6abbd;
  border-radius: 16px;
  position: relative;
}

.ts-well {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 1px solid rgba(255, 255, 255, 0.32);
  box-shadow: inset -8px -8px 16px 0 #fafbff, inset 8px 8px 16px 0 #a6abbd;
  border-radius: 16px;

  height: 100%;

  &.small {
    box-shadow: inset 2px 2px 6px 0 #a6abbd, inset -2px -2px 6px 0 #fafbff;
    border: solid 2px rgba(255, 255, 255, 0.4);
  }
}
</style>

<script>
export default {
  name: 'TsWell',
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  }
};
</script>
